import ConditionalRender from '../../ConditionalRender';
import AnProspectProfileCard from '../cta_utils/AnProspectProfileCard.js';
import { ClickableDropdown } from '../../design_system/components/Dropdown/Dropdown.jsx';
import { DropdownMenu } from '../../design_system/components/Dropdown/DropdownMenu.jsx';
import { DropdownItem } from '../../design_system/components/Dropdown/DropdownItem.jsx';
import { Avatar } from '../../design_system/components/Avatar/Avatar.jsx';
import Icons from '../../design_system/components/Icons/Icons.jsx';
import { Tag } from '../../design_system/components/Input Fields/Tag.jsx';
import { SuggestionBox } from '../../design_system/components/Input Fields/SuggestionBox.jsx';

const AnMultipleSuggestionInputBox = (props) => {

    /* Props accepted
        suggestionUrl -> api endpoint
        selectedOptions -> Array of options that are selected
        callback -> a callback to setSelectedOptions
        label(optional) -> label above input box
        inputClass(optional) -> pass any truthy value to show the search icon inside the box
        placeholder(optional) -> placeholder for box
        style(optional) -> style the component
    */
  let theme = props.theme || "default";

  const handleSelect = (_, item) => {
    if (!item) return;
    props.callback([...props.selectedOptions, item]);
  }

  const handleDeselect = (index) => {
    const newOptions = [...props.selectedOptions];
    newOptions.splice(index, 1);
    props.callback(newOptions);
  }

  const renderSelectedOptions = () => (
    <div className="multi-suggestion__tags flex items-center flex-wrap gap-s mt-s">
      {props.selectedOptions.map((opt, index) => (
        <Tag
          key={opt.id + index}
          label={opt.name || opt.company}
          Variant="filled"
          showClose
          onClick={() => handleDeselect(index)}
        />
      ))}
    </div>
  )

  const renderModernSelectedOptions = () => (
    <div className="multi-suggestion__modern-tags flex items-center flex-wrap gap-m mt-m">
      {props.selectedOptions.map((opt, index) => (
        <div key={opt.id + index} className="grid-container multi-suggestion__modern-item">
          <div className="grid-item">
            <div className="default_flex_container">
              <AnProspectProfileCard prospect={opt}>
                <a href={`/prospects/${opt.id}`} target='_blank' className="multi-suggestion__avatar-link">
                  <Avatar
                    name={opt.name || opt.company}
                    profile_image={opt.profile_image}
                    width={32}
                    fullProfileImageView={false}
                  />
                </a>
              </AnProspectProfileCard>
              <AnProspectProfileCard prospect={opt}>
                <div className="multi-suggestion__modern-info ml-l">
                  <a href={`/prospects/${opt.id}`} target='_blank' className="default_flex_container hover_under_line">
                    <span className="body-m color-text-primary truncate">{opt.name}</span>
                  </a>
                  <div className="body-s color-text-secondary truncate">{opt.company}</div>
                </div>
              </AnProspectProfileCard>
            </div>
          </div>
          <div
            className="grid-item multi-suggestion__modern-remove flex items-center justify-center cursor-pointer rounded-xs text-right"
            onClick={() => handleDeselect(index)}
          >
            <Icons name="close" size={16} />
          </div>
        </div>
      ))}
    </div>
  )

  const renderTaggedOptions = () => {
    const searchedProspects = [...(props.selectedOptions || [])]
    return (
      <ConditionalRender if={searchedProspects.length > 0}>
        <div className="multi-suggestion__tagged-list flex flex-wrap items-center gap-s">
          <Tag
            label={searchedProspects[0]?.name || searchedProspects[0]?.company}
            href={searchedProspects[0]?.id ? `/prospects/${searchedProspects[0].id}` : ""}
            target="_blank"
            Variant="filled"
            showClose
            onClick={() => handleDeselect(0)}
          />
          <ConditionalRender if={searchedProspects.length > 1}>
            <div className="multi-suggestion__more-trigger relative">
              <ClickableDropdown>
                <Tag
                  label={`+${searchedProspects.length - 1}`}
                  Variant="filled"
                  customStyle={{ cursor: 'pointer' }}
                />
                <DropdownMenu usePortal align="left" customStyle={{ width: 'max-content' }}>
                  {searchedProspects.slice(1).map((opt, index) => (
                    <DropdownItem key={opt.id || index}>
                      <div className="default_flex_container justify-between gap-m" style={{ width: '100%' }}>
                        <a
                          href={opt.id ? `/prospects/${opt.id}` : undefined}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="body-s link-default no-underline truncate"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {opt.name || opt.company}
                        </a>
                        <span
                          className="flex items-center cursor-pointer"
                          onClick={(e) => { e.stopPropagation(); handleDeselect(index + 1); }}
                        >
                          <Icons name="close" size={16} />
                        </span>
                      </div>
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </ClickableDropdown>
            </div>
          </ConditionalRender>
        </div>
      </ConditionalRender>
    )
  }

  return (
    <div style={props.style}>
      <ConditionalRender if={props.label}>
        <div className="multi-suggestion__label mb-xs">
          {props.label}
        </div>
      </ConditionalRender>
      {/* key resets the input after each selection, clearing the typed text */}
      <SuggestionBox
        Size="Large"
        key={props.selectedOptions.length}
        suggestionUrl={props.suggestionUrl}
        params={{ full_profile_info: true }}
        placeholder={props.placeholder}
        error={props.error}
        showIcon={!!props.inputClass}
        IconName={props.inputClass ? "search" : null}
        onSelect={handleSelect}
        renderOption={(item) => item.name || item.company}
        customStyle={props.style}
        usePortal={props.usePortal}
      />
      {theme === "default"
        ? renderSelectedOptions()
        : theme === 'tagged_options'
          ? renderTaggedOptions()
          : renderModernSelectedOptions()
      }
    </div>
  )
}

export default AnMultipleSuggestionInputBox
